import { environment } from '../environments'

export const getApiBaseUrl = () => environment().gotoApiBaseUrl

export const getJiveApiBaseUrl = () => environment().jiveApiBaseUrl
